export const getUrl = function (encode) {
  const url = window.location.href
  
  if (encode) {
    return encodeURIComponent(url)
  }
  
  return url
}
